import plotComponentFactory from "react-plotly.js/factory";
import Plotly from "plotly.js-dist";

const PlotComponent = plotComponentFactory(Plotly);

export default PlotComponent;